<div class="nova-font-style">
  <div class="notif-body text-black">
    <span>{{notifBody}}</span>
  </div>
  <button class="btn waves-effect full-width gotit-btn" type="button" (click)="close()">
    <span class="bold">Got it!</span>
  </button>
</div>
